<div class="flxClmn">
	<div class="page-title-container flxClmn-center">
		<div class="page-title-inner-container">
			<span class="page-title">Audit Log</span>
		</div>
		<div class="page-subtitle-container">
			<span class="page-subtitle">Track admin actions across your plan</span>
		</div>
	</div>
	<div class="page-inner-content-holder no-scroll flxClmn">
		<!--logs table-->
		<trustifi-table-c
			class="trustifi-table" style="flex: 1 0; z-index: 5;"
			[list]="logs"
			[headers]="[
                {text:'Date', sortKey:'created', width: '13%'},
                {text:'Category', sortKey:'category', width: '13%'},
                {text:'User', sortKey:'admin', width: '19%'},
                {text:'Action'},
            ]"
			[cellsPrototype]="[
                {textKey: 'created', textType: 'dateAndTime'},
                {textKey: 'category'},
                {textKey: 'admin', tooltip: true},
                {html: 'logActionCell'},
            ]"
			(searchFunction)="searchLogs($event)"
			[filterData]="filterData"
			[options]="{
                exportToCsvFunction: exportToCsv,
                loadingTableFlag: loadingLogsInProcess,
                refreshFunction: getDomainProtectionLogs,
                itemsNameSingular: 'log',
                defaultSortKey: '-created',
                itemUniqueIdentifier: '_id',
                isEllipsis: false,
                customButtons: [{icon: 'far fa-calendar-day', function: showScheduleReport, tooltip: 'Schedule Report'}],
            }"
		>
			<!--log action cells-->
			<ng-template #customCells let-item let-cellId="cellId">
				<div *ngIf="cellId === 'logActionCell'">
					<div class="flxRow-start hSpace1 expandable-record-row" style="max-width : 850px;" #expandableRecord
                         (click)="item.fullMode = !item.fullMode"
                         [ngStyle]="{'cursor': item.data ? 'pointer !important' : ''}">
						<i style="color : royalblue;" *ngIf="item.data" class="far fa-external-link-alt"></i>
						<div class="ellipsis" style="word-break : break-word;"
							 (isElps)="gs.setExpandableRecord(expandableRecord, $event)"
							 [ngStyle]="item.fullMode ? { 'white-space' : 'normal' , 'color' : item.data ? 'royalblue' : ''} : item.data ? {'color' : 'royalblue' } : null ">
							<span>{{item.action}}</span>
						</div>
						<i *ngIf="!item.fullMode" class="fas fa-caret-down fa-sm"></i>
					</div>
				</div>
			</ng-template>
			<!---->
			<div tableButtons>
				<div class="period-buttons-group bs-enabled flxRow hSpace1">
					<btn-c
						variant="{{period.value !== periodObj.value ? 'outlined' : ''}}"
						*ngFor="let periodObj of auditLogsPeriod"
						[isDisabled]="loadingLogsInProcess"
						(action)="changePeriod(periodObj);">
						{{periodObj.display}}
					</btn-c>
					<!--CC: taken from inbound-trends.component.html -> custom period button-->
					<div class="toggled-menu-container" id="rangePeriodBtn">
						<btn-c
							variant="{{period.value !== dic.CONSTANTS.trendsPeriod.range.value ? 'outlined' : ''}}"
							[isDisabled]="loadingLogsInProcess"
							(action)="showCustomPeriodDropdown = !showCustomPeriodDropdown;">
							<span *ngIf="period.value !== dic.CONSTANTS.trendsPeriod.range.value">{{dic.CONSTANTS.trendsPeriod.range.display}}</span>
							<span *ngIf="period.value === dic.CONSTANTS.trendsPeriod.range.value">{{range.start | date:'MM/dd/yyyy'}} - {{range.end | date:'MM/dd/yyyy'}}</span>
						</btn-c>
						<div class="drop-menu p-2" style="width: fit-content; max-width: none; min-height: 0; overflow: visible;"
							 [ngClass]="{'active' : showCustomPeriodDropdown}">
							<div class="flex-row align-items-center gap-2 p-2"
								 (clickOutside)="showCustomPeriodDropdown = false;"
								 [exclude]="'#rangePeriodBtn'">
								<date-picker-c style="min-width: 250px;"
									[(dateModel)]="range"
									[isRange]="true"
									[dateFormat]="'mm/dd/yyyy'"></date-picker-c>
								<btn-c endIcon="zmdi zmdi-check"
									   [loading]="loadingLogsInProcess"
									   (action)="changePeriod(dic.CONSTANTS.trendsPeriod.range);
										getLogsByRangeDates();
										showCustomPeriodDropdown = false;">
									Get Logs
								</btn-c>
							</div>
						</div>
					</div>
				</div>
			</div>
		</trustifi-table-c>
	</div>
</div>

<audit-log-schedule-report-component [(show)]="scheduleReportShow"></audit-log-schedule-report-component>


